import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Container, Row, Col, Spacer } from '@cleartrip/bento/lib';
import { Table, TRow, TCol } from '../../../components/Table';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "typography"
    }}>{`Typography`}</h1>
    <p>{`Cleartrip has always stood for attention to detail. Type is one of the major elements of our booking experience`}</p>
    <h2 {...{
      "id": "font-families"
    }}>{`Font families`}</h2>
    <p>{`Bento uses system font stack for Mac, Windows and Linux to stay close to the native experience.`}</p>
    <div className="flex pb-5">
      <span className="w-10p fs-body-2">Sans</span>
      <code>-apple-system", "BlinkMacSystemFont", sans-serif</code>
    </div>
    <div className="flex pb-5">
      <span className="w-10p fs-body-2">Serif</span>
      <code>"Georgia", "Times New Roman", "Times", serif</code>
    </div>
    <div className="flex pb-5">
      <span className="w-10p fs-body-2">Mono</span>
      <code>"SFMono-Regular", "Consolas", "Menlo", "Courier", monospace</code>
    </div>
    <h2 {...{
      "id": "font-sizes"
    }}>{`Font sizes`}</h2>
    <Table mdxType="Table">
    <TRow className="flex flex-between p-3 bg-grey-05 c-pointer" mdxType="TRow">
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            Type
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            Size
        </TCol>
        <TCol className="flex-1 flex flex-start c-grey-50 fw-500" mdxType="TCol">
            Line height
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Caption
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            10px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            12px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-caption-2" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Caption-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            12px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            16px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-body" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Body
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            14px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            20px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-body-2" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Body-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            16px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            20px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-body-2" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Body-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            20px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            28px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-heading" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Heading
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            24px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            32px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-heading-2" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Heading-2
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            32px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            44px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-heading-3" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Heading-3
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            36px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            48px
        </TCol>
    </TRow>
    <TRow className="flex flex-between p-3 c-pointer fs-display" mdxType="TRow">
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            Display
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            48px
        </TCol>
        <TCol className="flex-1 flex flex-start" mdxType="TCol">
            56px
        </TCol>
    </TRow>
    </Table>
    <h2 {...{
      "id": "font-weights"
    }}>{`Font weights`}</h2>
    <div className="flex">
      <span className="fs-body-2 fw-100 pr-3">100</span><span className="fs-body-2 fw-200 pr-3">200</span><span className="fs-body-2 fw-300 pr-3">300</span><span className="fs-body-2 fw-400 pr-3">400</span><span className="fs-body-2 fw-500 pr-3">500</span><span className="fs-body-2 fw-600 pr-3">600</span><span className="fs-body-2 fw-700 pr-3">700</span><span className="fs-body-2 fw-800 pr-3">800</span><span className="fs-body-2 fw-900 pr-3">900</span>
    </div>
    <h2 {...{
      "id": "letter-spacing"
    }}>{`Letter spacing`}</h2>
    <p>{`Defines the spacing between the characters of a block of text.`}</p>
    <div>
      <div className="flex pb-5">
        <span className="flex flex-start w-10p fs-body-2 ls-tight">Tight</span>
        <code className="flex flex-center w-30p">letter-spacing: -1px</code>
        <span className="flex flex-1 flex-start ls-tight fs-body-2 pl-5">Tightly letter-spaced at -1px</span>
      </div>
      <div className="flex pb-5">
        <span className="flex flex-start w-10p fs-body-2 ls-normal">Normal</span>
        <code className="flex flex-center w-30p">letter-spacing: 0px</code>
        <span className="flex flex-1 flex-start ls-normal fs-body-2 pl-5">No additional letter-spacing applied</span>
      </div>
      <div className="flex pb-5">
        <span className="flex flex-start w-10p fs-body-2 ls-wide">Wide</span>
        <code className="flex flex-center w-30p">letter-spacing: 1px</code>
        <span className="flex flex-1 flex-start ls-wide fs-body-2 pl-5">Loosely letter-spaced at 1px</span>
      </div>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      